export class Denomination {
    id: string;
    number: number;
}


export const Menhgia: Array<Denomination> = [
    {id: '500', number: 500000},
    {id: '200', number: 200000},
    {id: '100', number: 100000},
    {id: '50', number: 50000},
    {id: '20', number: 20000},
    {id: '10', number: 10000},
    {id: '5', number: 5000},
    {id: '2', number: 2000},
    {id: '1', number: 1000}
];

export const Menhgia_Cashin: Array<Denomination> = [
  { id: '1000', number: 1000000 },
  { id: '500', number: 500000 },
  { id: '200', number: 200000 },
  { id: '100', number: 100000 },
  { id: '50', number: 50000 },
  { id: '20', number: 20000 },
];



// WEBPACK FOOTER //
// ./src/app/models/Denomination.model.ts